var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-box"},[_c('div',{staticClass:"one-title"},[_vm._v("热销产品销售占比")]),_vm._v(" "),_c('div',{staticClass:"one-part-box"},[_c('div',{staticClass:"content"},[_c('j-3D-swipe',{attrs:{"maxWidth":"180px","imgList":_vm.imgList,"blurPause":false,"autoPlay":true,"multiple":"1.1"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aaaacd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/moudles/ProductMoudle.vue
// module id = null
// module chunks = 